module.exports = __webpack_public_path__ + "img/sagume kishin_lw.075e63dd.png";